<div *ngIf="showView" class="floatover-container" [style.top.px]="styleTop" [style.left.px]="styleLeft">
  <div class="content-area">
    <div class="body">
      <ion-spinner *ngIf="loading; else content"></ion-spinner>
      <ng-template #content>
        <div [innerHTML]="inputHtml"></div>
      </ng-template>
    </div>
  </div>
</div>
